import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { isFunction } from '../type'
import {
  makePathnameWithLanguage,
  makeQueryString,
  withoutLanguage,
} from '../url'
import { useLanguage } from './useLanguage'

type QueryObject = Record<string, string | number | boolean | undefined>
type StateObject = Record<string, any>

type PathFunction<T = string | Record<string, string>> = (key: T) => string

export const useGoToPath = <T = string | Record<string, string>,>(
  path: string | PathFunction<T>,
  queryObject: QueryObject = {},
  state: StateObject = {},
): ((key?: T) => void) => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const language = useLanguage()
  const makePath = makePathnameWithLanguage(language)

  return useCallback(
    (key?: T) => {
      // @ts-expect-error this is to be fixed when ramda gets removed
      const resolvedPath = makePath(isFunction(path) ? path(key) : path)
      const fullPath = `${resolvedPath}${makeQueryString(queryObject)}`
      navigate(fullPath, {
        state: {
          from: withoutLanguage(pathname),
          ...state,
        },
      })
    },
    [path, language, pathname, queryObject, state, navigate, makePath],
  )
}
